import React from 'react';
import { Box, Typography, Avatar, alpha, useTheme } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { StyledCard, StyledCardHeader, StyledCardContent, MetricChip, formatDisplayItem } from '@features/analysis/components/StyledComponents';
import { MarketAnalysisCardProps } from '@features/analysis/types';

const MarketAnalysisCard: React.FC<MarketAnalysisCardProps> = ({ analysis }) => {
  const theme = useTheme();
  const marketAnalysis = analysis.marketAnalysis;

  return (
    <StyledCard>
      <StyledCardHeader
        title="Market Analysis"
        subheader="Understanding market dynamics and positioning"
        avatar={
          <Avatar sx={{ bgcolor: alpha(theme.palette.info.main, 0.1), color: theme.palette.info.main }}>
            <TrendingUpIcon />
          </Avatar>
        }
      />
      <StyledCardContent>
        <Typography variant="body1" sx={{ mb: 3, color: theme.palette.text.secondary }}>
          {marketAnalysis?.summary || 'No summary provided.'}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box>
            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
              Demand Drivers
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {marketAnalysis?.demandDrivers && marketAnalysis.demandDrivers.length > 0 ? (
                marketAnalysis.demandDrivers.map((driver, index) => (
                  <MetricChip
                    key={`${index}-driver`}
                    label={formatDisplayItem(driver)}
                    color="info"
                    variant="outlined"
                  />
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No demand drivers listed.
                </Typography>
              )}
            </Box>
          </Box>
          <Box>
            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, color: theme.palette.text.primary }}>
              Market Risks
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {marketAnalysis?.risks && marketAnalysis.risks.length > 0 ? (
                marketAnalysis.risks.map((risk, index) => (
                  <MetricChip
                    key={`${index}-risk`}
                    label={formatDisplayItem(risk)}
                    color="error"
                    variant="outlined"
                  />
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No risks identified.
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </StyledCardContent>
    </StyledCard>
  );
};

export default MarketAnalysisCard;